import { useEffect } from "react";

const version = "20241002T075451623Z";

const AppVersion = () => {
	useEffect(() => {
		const date = new Date()
			.toISOString()
			.replaceAll("-", "")
			.replaceAll(":", "")
			.replaceAll(".", "");
		console.log(date);
	}, []);

	return (
		<div
			style={{
				margin: "24px 0px",
				opacity: 0.5,
			}}
		>
			Version 1.0.0.
			{version}
		</div>
	);
};

export default AppVersion;
